import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const WelcomeSliderContainer = styled.div`
  top: 0;
  left: 0;
  height: 100%;
  transition: ease-in-out .3s;
  position: absolute;
  width: 100%;
  z-index: 999;
  background: ${colors.bgOverlay};
  position: fixed;
`;

export const WelcomeSliderContent = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const WelcomeSliderModal = styled.div`
  padding: 30px;
  width: 100%;
  max-width: 540px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const WelcomeSliderHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;

export const WelcomeSliderBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;

  img {
    width: 100%;
    max-width: 170px;
  }
`;

export const WelcomeSliderBodyTitle = styled.h5`
  font-weight: 600;
  font-size: 20px;
  color: ${colors.textPrimary};
  margin-top: 40px;
  text-align: center;
  transition: .1s;
  opacity: ${prop => prop.show ? 1 : 0};
`;

export const WelcomeSliderBodyText = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: ${colors.textPrimary};
  margin-top: 15px;
  text-align: center;
  transition: .1s;
  opacity: ${prop => prop.show ? 1 : 0};
`;

export const WelcomeSliderBodyStepsContent = styled.div`
  display: flex;
  justify-content: center;
`;

export const WelcomeSliderBodyStep = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: ${prop => prop.active ? colors.bgPrimary : colors.grayLight};
  cursor: pointer;
  margin-top: 30px;

  & + & {
    margin-left: 15px;
  }
`;

export const WelcomeSliderFooter = styled.div`
  display: flex;
  justify-content: center;
`;

export const WelcomeSliderButton = styled.span`
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  color: ${colors.bgPrimary};
  cursor: pointer;
`;

export const WelcomeSliderImage = styled.img`
  transition: .2s;
  opacity: ${prop => prop.show ? 1 : 0};
`;
